import React from 'react'
import {Card, CardBody, CardHeader, Col, Row} from 'reactstrap'
import classNames from 'classnames'
import parseGGDriver from '../helpers/parseGGDriver'

class ShipItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoadingPrinting: false
        }
    }

    _renderDesignImage = (src, style, alt, arx4Name) => {
        if (src) return <a href={`C:\\Users\\ASUS\\Google Drive\\Arx4\\${arx4Name}.arx4`} target="_self">
            <img src={src} style={style} alt={alt}/>
        </a>
        return <div className='image'>150 x 200</div>
    }

    _renderMockUpImage = (src) => {
        if (src)
            return <div className='mockUpImage' style={{backgroundImage: `url("${src}")`}}/>
        return <div className='image'>150 x 200</div>
    }

    render() {
        const {barcodeNumber, pos, product} = this.props
        const {mockUpFront, mockUpBack, designFront, designBack, size, color, status: productStatus} = product

        const urlMockUpFront = parseGGDriver(mockUpFront)
        const urlMockUpBack = parseGGDriver(mockUpBack)
        const urlDesignFront = parseGGDriver(designFront)
        const urlDesignBack = parseGGDriver(designBack)

        const isCompleted = productStatus === 'completed'

        const printItemClassName = classNames({
            ShipItem: true,
            Completed: isCompleted
        })

        const arx4Name = barcodeNumber.replace('#', '') + '_' + pos.split('/')[0]

        return (
            <div className={printItemClassName}>
                <Card>
                    <CardHeader className='PrintItemHeader'>
                        <h4 className='d-flex justify-content-between align-items-center w-100 font-weight-bold mb-2'>
                            <div className='text-primary'>{pos}</div>
                        </h4>
                    </CardHeader>
                    <CardBody>
                        <div>
                            <h3>Size: {size}</h3>
                            <h3>Color: {color}</h3>
                        </div>
                        <Row>
                            <Col md={6} className='d-flex flex-column align-items-center'>
                                <div className='font-size-lg font-weight-bold'>MẶT TRƯỚC</div>
                                <div className='mockUp mt-3'>
                                    <span className='Title'>Mock Up</span>
                                    {this._renderMockUpImage(urlMockUpFront)}
                                </div>
                                <div className='design mt-3'>
                                    <span className='Title'>Design</span>
                                    {this._renderDesignImage(urlDesignFront, {backgroundColor: color}, 'design front', arx4Name + '_F')}
                                </div>
                            </Col>
                            <Col md={6} className='d-flex flex-column align-items-center'>
                                <div className='font-size-lg font-weight-bold'>MẶT SAU</div>
                                <div className='mockUp mt-3'>
                                    <span className='Title'>Mock Up</span>
                                    {this._renderMockUpImage(urlMockUpBack)}
                                </div>
                                <div className='design mt-3'>
                                    <span className='Title'>Design</span>
                                    {this._renderDesignImage(urlDesignBack, {backgroundColor: color}, 'design back', arx4Name + '_B')}
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

export default ShipItem
